import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import type { ProgressStatus } from './progress-types.ts';
import { ProgressBarItem } from './ProgressBarItem.tsx';
// oxlint-disable-next-line import/no-cycle
import { ProgressPercentage, ProgressText } from './ProgressModal.tsx';
import { ProgressMessage } from './ProgressMessage.tsx';

export const i18n: {
	uploadModalProgressTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	uploadModalProgressTitle: {
		id: 'import-from-sources.upload-modal.progressTitle',
		defaultMessage: 'Importing document…',
		description: 'Status message when importing is in progress',
	},
});

type ProgressSingleDocModalProps = {
	status: ProgressStatus;
	progress: number;
};

export const ProgressSingleDocModal: React.FC<ProgressSingleDocModalProps> = ({
	status,
	progress,
}) => {
	const { formatNumber } = useIntl();
	return (
		<>
			<ProgressText>
				<ProgressMessage status={status} message={i18n.uploadModalProgressTitle} />
				<ProgressPercentage>
					{formatNumber(progress / 100, { style: 'percent' })}
				</ProgressPercentage>
			</ProgressText>
			<ProgressBarItem progress={progress} />
		</>
	);
};
